module.exports = __webpack_public_path__ + "static/media/han-taste-ad1.2160372c.jpg";